import styled from "@emotion/styled";
import { Container, Typography, Button } from "@mui/material";

export const RootBox = styled(Container)({
  background: "#fff",
  padding: "4rem",
  borderRadius: "0.5rem",
});

export const LoginTitle = styled(Typography)({
  fontSize: 20,
  fontWeight: 500,
  // fontFamily: ['Inter', 'sans-serif'].join(','),
  color: "#565656",
  marginBottom: "1.5rem",
  textAlign: "center",
});

export const SocialPill = styled(Button)(({ theme }: any) => ({
  background: "#FFF",
  borderRadius: "100%",
  padding: 0,
  minWidth: "30px",
}));
